import { Age, BadgeId } from "@common";
import React, { useState } from "react";

interface MultiplayerSettingsContextType {
  age: Age;
  modulesInQuiz: Array<BadgeId>;
  setAge: React.Dispatch<React.SetStateAction<Age>>;
  setModulesInQuiz: React.Dispatch<React.SetStateAction<Array<BadgeId>>>;
}

export const MultiplayerSettingsContext = React.createContext<MultiplayerSettingsContextType>({
  age: "youth",
  modulesInQuiz: [],
  setAge: () => null,
  setModulesInQuiz: () => null,
});

export const MultiplayerSettingsProvider: React.FC<{
  children: React.ReactElement;
}> = ({ children }) => {
  const [age, setAge] = useState<Age>("youth");
  const [modulesInQuiz, setModulesInQuiz] = useState<Array<BadgeId>>([]);
  return (
    <MultiplayerSettingsContext.Provider
      value={{
        age,
        modulesInQuiz,
        setAge,
        setModulesInQuiz,
      }}
    >
      {children}
    </MultiplayerSettingsContext.Provider>
  );
};
